import React, { Component } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import { ActivityLogList_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
class ActivityLogListDialog extends Component {
  header = store.getState().header.header;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  constructor(props) {
    super(props);
    this.state = {
      messageName: "",
      initialPage: 0,
      pageSize: 20,
      activityList: [],
      open: false,
    };
  }

  showActivityLogList(rowData) {
    const postObject = {
      header: this.header,
      messageLog: {
        id: rowData.id,
      },
    };
    FetchServerData.callPostService(ActivityLogList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let activityList = output.data.activityList;
          let isPaging = false;
          for (let i = 0; i < activityList.length; i++) {
            activityList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(activityList[i].createdOn, true) : Utils.getUtcToLocalDateTimeZone(
              activityList[i].createdOn, true
            );
          }
          if (activityList.length > this.state.pageSize) {
            isPaging = true;
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            messageName: rowData.messageName,
            activityList: activityList,
          });
        } else {
        }
      }
    );
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  toActivityDetails(data) {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventActivityContactList", {
        state: {
          messageId: data.id,
          messageName: data.messageName,
          pageId: "PreviewAndSend",
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextActivityContactList", {
        state: {
          messageId: data.id,
          messageName: data.messageName,
          pageId: "PreviewAndSend",
        },
      });
    } else {
      this.props.navigate("/activityContactList", {
        state: {
          messageId: data.id,
          messageName: data.messageName,
          pageId: "PreviewAndSend",
        },
      });
    }
  }

  toActiveCount(rowData) {
    return (
      <span
        style={{
          float: "right",
          color: "#337ab7",
          textDecoration: "none",
          cursor: "pointer",
        }}
        onClick={(e) => this.toActivityDetails(e, rowData)}
      >
        {" "}
        {rowData.activeContacts}
      </span>
    );
  }

  render() {
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="activityDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>
              This page shows the lists that were sent this message.
            </span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent className="p-4">
            <div
              md={12}
              className="tableContact materialTable"
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
              }}
            >
              <MaterialTable
                title=""
                icons={UiUtils.getMaterialTableIcons()}
                localization={{
                  body: {
                    emptyDataSourceMessage: <h5>No data found.</h5>,
                  },
                }}
                columns={[
                  {
                    title: "#",
                    render: (rowData) => rowData.tableData.id + 1,
                    width: "5%",
                    align: "left",
                    cellStyle: {
                      width: "6%",
                    },
                  },
                  {
                    title: "Message name",
                    field: "messageName",
                    cellStyle: {
                      width: "20%",
                    },
                  },
                  {
                    title: "Message type",
                    field: "messageType",
                    cellStyle: {
                      width: "20%",
                    },
                  },
                  {
                    title: "Message keyword",
                    field: "messageKeyword",
                    cellStyle: {
                      width: "22%",
                    },
                  },
                  {
                    title: "Active contacts",
                    field: "activeContacts",
                    cellStyle: {
                      width: "20%",
                      textAlign: "center",
                    },
                    headerStyle: {
                      textAlign: "right",
                    },
                  },
                ]}
                data={this.state.activityList}
                options={{
                  showTextRowsSelected: false,
                  emptyRowsWhenPaging: false,
                  sorting: true,
                  search: false,
                  actionsColumnIndex: -1,
                  initialPage: this.state.initialPage,
                  pageSize: this.state.pageSize,
                  pageSizeOptions: Utils.materialTablePageSize(),
                  paging: this.state.isPaging,
                  // headerStyle: {
                  //   backgroundColor: "#37517e",
                  //   fontWeight: "bold",
                  //   color: "#fff",
                  //   align: "left",
                  // },
                  rowStyle: (rowData) => ({
                    backgroundColor:
                      rowData.id === this.state.contactId ? "#FEF5E7" : "",
                    height: "3em",
                    textTransform: "capitalize",
                  }),
                }}
                onSelectionChange={(rowData) => {
                  this.rowItemSelected(rowData);
                }}
                onChangePage={(page, pageSize) => {
                  this.handleMaterialTablePageChange(page, pageSize);
                }}
              />
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default ActivityLogListDialog;
